module.exports = __webpack_public_path__ + "static/img/aboutTop2-05.bf6cf14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutTop2-05.png
// module id = hZBT
// module chunks = 1